import { INTERNAL_EMAIL_DOMAINS } from '@/utils/isInternalEmail';

export const MAX_EMAILS_PER_INVITATION = 20;

export const RESTRICTED_EMAIL_ERROR_MESSAGE = `This project only allows emails with the following domains: ${INTERNAL_EMAIL_DOMAINS.join(
  ', '
)}`;
